import images from './*.png'
import sounds from './*.ogg'

const assets = { images, sounds }

export default assets
